import { v4 } from 'uuid';
import { TableSettings } from '../TableSettings';
import { EntityType } from '../../comment';
import { translate } from '../../translation/Translator';

export const OrderProductTransactionTableSettingsColumn = {
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  processedAt: 'processedAt',
  processedBy: 'processedBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy',
  quantity: 'quantity',
  processQuantity: 'processQuantity',
  status: 'status',
  type: 'type',
  productNumber: 'productNumber',
  productName: 'productName',
  sourceBin: 'sourceBin',
  destinationBin: 'destinationBin',
  sourceStockLocation: 'sourceStockLocation',
  destinationStockLocation: 'destinationStockLocation',
  lotNumber: 'lotNumber',
  serialNumber: 'serialNumber',
  lpn: 'lpn',
  countryOfOrigin: 'countryOfOrigin',
  destinationContainer: 'destinationContainer',
  sourceContainer: 'sourceContainer',
} as const;

export type OrderProductTransactionTableSettingsColumn =
  (typeof OrderProductTransactionTableSettingsColumn)[keyof typeof OrderProductTransactionTableSettingsColumn];

export class OrderProductTransactionTableSettings {
  static default(companyId: string) {
    return new TableSettings<OrderProductTransactionTableSettingsColumn>({
      id: v4(),
      companyId,
      type: EntityType.productTransaction,
      parentType: EntityType.order,
      columns: [
        {
          index: 0,
          column: OrderProductTransactionTableSettingsColumn.productName,
          label: translate({ key: OrderProductTransactionTableSettingsColumn.productName }),
        },
        {
          index: 1,
          column: OrderProductTransactionTableSettingsColumn.productNumber,
          label: translate({ key: OrderProductTransactionTableSettingsColumn.productNumber }),
        },
        {
          index: 2,
          column: OrderProductTransactionTableSettingsColumn.processedAt,
          label: translate({ key: OrderProductTransactionTableSettingsColumn.processedAt }),
        },
        {
          index: 3,
          column: OrderProductTransactionTableSettingsColumn.processedBy,
          label: translate({ key: OrderProductTransactionTableSettingsColumn.processedBy }),
        },
        {
          index: 4,
          column: OrderProductTransactionTableSettingsColumn.quantity,
          label: translate({ key: OrderProductTransactionTableSettingsColumn.quantity }),
        },
        {
          index: 5,
          column: OrderProductTransactionTableSettingsColumn.status,
          label: translate({ key: OrderProductTransactionTableSettingsColumn.status }),
        },
      ],
    });
  }
}
